export default "__VITE_ASSET__qlUzZBL1__"